import {Component, ErrorHandler, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ActionIconComponent} from '../action-icon/action-icon.component';
import {State} from '../state-view/state.model';
import {UserInfo} from '../models/user-info.model';
import {AuthService} from '../../auth/auth/auth.service';
import {UserService} from '../user/user.service';
import {MatSnackBar} from '@angular/material';
import {IAuthEvent} from '../../auth/models/auth-event.model';
import { Review } from '../models/review.model';

@Component({
  selector: 'app-thumbsdown-icon',
  templateUrl: './thumbsdown-icon.component.html',
  styleUrls: ['./thumbsdown-icon.component.scss']
})
export class ThumbsdownIconComponent implements OnInit {
  @Input() isLiked: boolean;
  @Input() entityId: number;
  @Input() isAirport: boolean;
  @Input() review: Review;
  @Output() toggle = new EventEmitter<Review>();
  @ViewChild('iconCmp') iconCmp: ActionIconComponent;
  authenticated = false;
  state = State.Empty;
  private _userInfo: UserInfo;

  constructor(private _auth: AuthService,
              private _userService: UserService,
              private _errorHandler: ErrorHandler,
              private _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    // Update state based on latest event in authStream, and subscribe to any future
    // changes in authentication state.
    this._onAuthEvent(this._auth.authStream.getValue());
    this._auth.authStream.subscribe(e => this._onAuthEvent(e));

    // Update state based on latest available userInfo, and subscribe to any future
    // changes to userInfo.
    this._userInfo = this._userService.userInfo.getValue();
    this._userService.userInfo.subscribe(u => {
      // Update userInfo
      this._userInfo = u;
      // Set state to loaded
      this.state = State.Content;
    });
  }

  get isThumbset(): boolean {
    return this._userInfo && (this.isLiked);
  }

  get tooltip(): string {
    return this.isLiked
      ? 'You disliked this comment' +
      '(click to remove)'
      : 'Dislike this comment';
  }

  get icon(): string {
    return 'thumb_down';
  }

  private _onAuthEvent(e: IAuthEvent) {
    this.authenticated = this._auth.authenticated;
    if (this.authenticated && !this._auth.endUser) {
      // userInfo is not available when not authenticated as an end user, so set favorite state to loaded now.
      this.state = State.Content;
    }
  }

  async toggleSetting(v) {
    if (!this._auth.authenticated || !this._auth.endUser) {
      this._auth.redirectToLogin();
      return;
    }

    this.state = State.Loading;
    const snackBarOpts = {duration: 2000};
    try {
      if (this.review.interactions.myDownVote) {
        if (this.isAirport) {
          const response = await this._userService.setAirportInteraction(this.entityId, this.review.id, 'ClearVote');
          this.review = Review.parse(response);
        } else {
          const response = await this._userService.setBusinessInteraction(this.entityId, this.review.id, 'ClearVote');
          this.review = Review.parse(response);
        }
        this.isLiked = false;
        // this._snackBar.open(`Comment no longer liked.`, 'Dismiss', snackBarOpts);
      } else {
        if (this.isAirport) {
          const response = await this._userService.setAirportInteraction(this.entityId, this.review.id, 'DownVote');
          this.review = Review.parse(response);
        } else {
          const response = await this._userService.setBusinessInteraction(this.entityId, this.review.id, 'DownVote');
          this.review = Review.parse(response);
        }
        this.isLiked = true;
        // this._snackBar.open(`Comment liked.`, 'Dismiss', snackBarOpts);
      }
      this.state = State.Content;
      this.toggle.emit(this.review);
    } catch (e) {
      this._snackBar.open('An error occurred saving your dislike/downVote. Please try again later.', 'Dismiss', snackBarOpts);
      this._errorHandler.handleError(e);

      // Set state to error, then reset after a few seconds to allow retry.
      this.state = State.Error;
      setTimeout(() => {
        this.state = State.Content;
      }, 2000);
    }
  }
}
